module.exports = __webpack_public_path__ + "c62ca9789f737fd4693f047ff7bbdd1b.png";